// extracted by mini-css-extract-plugin
module.exports = {"toggleView":"styles_toggleView__3oCED","button":"styles_button__3qqjK","activeButton":"styles_activeButton__3gHL1"};